import React from "react";

const EvenMorePain = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_939_533)">
                <ellipse cx="24.0002" cy="24" rx="22.9787" ry="23" fill="white" />
                <path
                    d="M23.9822 47.9965C11.4757 47.9823 0.0495513 38.2937 -0.00181405 24.0434C-0.0460945 10.4996 10.4891 0.0920799 23.8919 -6.47246e-06C37.7499 -0.0850092 48.0761 11.0893 47.9982 24.0699C47.9167 38.2955 36.0797 48.1877 23.9822 47.9965ZM24.0549 46.029C35.7573 45.9918 45.9418 36.7442 46.0304 24.0699C46.1119 12.205 36.7155 1.96745 23.9539 1.95683C12.82 1.9462 2.05811 10.3562 1.99081 23.9283C1.91996 37.0754 12.4658 46.0432 24.0549 46.029Z"
                    fill="black"
                />
                <path
                    d="M15.0128 18.2048C17.1382 18.2774 18.8209 20.0199 18.7855 22.1007C18.75 24.2081 16.7592 26.149 14.7117 26.0658C12.4675 25.9754 10.8291 24.201 10.8929 21.929C10.9602 19.5896 12.5862 18.1215 15.0128 18.2048Z"
                    fill="black"
                />
                <path
                    d="M33.1998 26.064C31.0886 26.064 29.3935 24.3622 29.3492 22.1928C29.3014 19.7756 30.8512 18.1853 33.2459 18.2012C35.4511 18.2154 37.1869 19.857 37.2347 21.9732C37.2825 24.0894 35.3164 26.0604 33.1998 26.064Z"
                    fill="black"
                />
                <path
                    d="M31.2778 34.2402C30.9643 35.1664 30.7039 35.9402 30.4577 36.6628C28.1552 36.2307 26.1253 35.5666 24.0814 35.5471C22.1153 35.5294 20.1439 36.1775 17.8963 36.5831C17.6442 36.4511 17.4242 36.2655 17.2515 36.0394C16.4687 34.7785 16.644 34.1145 17.9777 33.6044C22.3314 31.9416 26.6284 31.9681 31.2778 34.2402Z"
                    fill="black"
                />
                <path
                    d="M15.2307 12.2121C14.7241 12.6389 14.4 12.9576 14.0333 13.2126C12.7935 14.0821 11.4296 14.8188 10.3138 15.8229C9.42814 16.6074 8.82239 17.6965 8.13516 18.6811C7.83582 19.1097 7.49043 19.5666 7.01043 19.2124C6.75892 19.0353 6.62254 18.327 6.76423 18.0135C7.81617 15.6364 9.64572 13.6879 11.9521 12.4883C12.6554 12.1033 13.3983 11.7957 14.1679 11.571C14.3982 11.5055 14.7595 11.911 15.2307 12.2121Z"
                    fill="black"
                />
                <path
                    d="M41.7989 17.5832C41.6324 17.8329 41.542 18.095 41.3596 18.1994C41.1496 18.3035 40.9069 18.32 40.6848 18.2455C40.4707 18.1359 40.2906 17.97 40.164 17.7656C38.5327 15.5201 36.3488 14.0981 33.6991 13.3224C33.1341 13.1559 32.2361 13.0692 32.4592 12.1625C32.6983 11.1991 33.4812 11.6525 34.0533 11.8083C36.89 12.5522 39.3953 14.2258 41.1683 16.5614C41.3968 16.8903 41.6073 17.2314 41.7989 17.5832V17.5832Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_939_533">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EvenMorePain;
